import { Injectable } from '@angular/core';
import { IrbClientsEvents, IrbRebalanceEvents } from '@irb/irb-common/events';
import { formatSecurityTypeReverse, formatTransactionReverse } from '@irb/irb-common/formatters';
import { InventoryComponent } from './inventory.component';


@Injectable({
  providedIn: 'root'
})
export class CellrenderInfoService {

  constructor() { }


  cellRendererSelectorRebalId(inventory:InventoryComponent,params: any) {
     if (params && params.data && !params.data.isBlockOrder && !params.data.isImported && params.data.pfAuthstatus?.toLowerCase() !== "unauthorized") {
        return {
            component: "cellRendererFormatter",
            params: {
              link: (params: any) => {
              
                return params.value !== null;
              },
              onClick: () => {
                inventory.dialog.closeAll();
                inventory.showPortfolioResultDetail(params.data.rebalanceResultId, params.data.portfolioId);
              },
            },
          };
      } else{
        const displayValue = params && params.data && (params.data.isImported || params.data.pfAuthstatus?.toLowerCase() === "unauthorized") ? params.data.rebalanceResultId : '';
        return {
          component: "cellRendererFormatter",
          params: { value :displayValue}
        }
      }

  }

    cellRendererSelectorBlockOrders(inventoryComponent:InventoryComponent,params: any,) { 
      
      if (params && params.data && params.data.isBlockOrder) {
          return {
              component: "cellRendererFormatter",
              params: {
                link: (params: any) => {
                  return params.value !== null && params.value.length > 0;
                },
                onClick: function () {
                this.pfs.getComponentOrders(params.data.orderID, params.context.componentParent.current, params.data.createdDate, this.pfs.isArchivedOrders).subscribe((res: any) => {
                if(res !=null){                
                  inventoryComponent.blockOrdersDialog(res,params.data);
                }
               });
                }.bind(this),
              },
            };
      } else {
          // For regular (non-block) orders, return renderer with calltoaction
          return {
              component: "cellRendererFormatter",
              params: {
                link: (params: any) => {
                  return (params.value != null && params.value.length > 0);
                },
                calltoactionTemplateFunc: inventoryComponent.ENABLE_FLYOUT ? (p: any) => inventoryComponent.getTemplate(p) : undefined
              }
          };
      }
    }

      cellRendererSelectorAccountName(params: any) {           
      if (params.data) {
        if ( params.data.isBlockOrder) {
            return {
              component: 'cellRendererFormatter',
              params:{value:"Combined"},                
              };
          } else {
              return{
              component: 'cellRendererFormatter',
                  params:{ value:params.data.accountName } 
            };
        }
      }
    }
    cellRendererSelectorFees(params: any) {    
      const rowItem = params.data;       
      if (rowItem) {
        if ( rowItem.isBlockOrder) {
            return {
              component: 'cellRendererFormatter',
              params:{value:'n/a'},
              };
          } else {
            let returnValue:string = '';
            if (rowItem.securityType == "Mutual Fund") {
              if (rowItem.orderStatus == "SUBMITTED_TO_VEO" || rowItem.transactionType == "Sell All" ||
                (rowItem.transactionType == "Sell" && rowItem.amountType == "Shares")){
                returnValue =   params.value[0].toUpperCase() + params.value.substr(1).toLowerCase(); //TODO: check with Legacy if edit required
              } else {
                returnValue =   params.value[0].toUpperCase() + params.value.substr(1).toLowerCase();
              }
            }
            if (!returnValue) {returnValue =  'n/a';}
            return{
              component: 'cellRendererFormatter',
                  params:{ value:returnValue } 
            };
        }
      }
    }

  cellRendererSelectorOrderType(params: any,inventoryComponent:InventoryComponent) {   
   
    const rowItem = params.data;       
    if (rowItem) {
      if ( rowItem.isBlockOrder ||   rowItem.isBlockOrder == null) { 

        let isOption = rowItem.securityType == "Option";
				let isAllowedSecurityType = (rowItem.securityType == "Equity" || rowItem.securityType == "Option");
				let isAllowedOptionTrading = (inventoryComponent.isOptionTradeEnabled && isOption) || !isOption;


        if (isAllowedSecurityType && isAllowedOptionTrading) {
          return this.formatTradeInstruction(rowItem.orderType,params,inventoryComponent);
        }else if(isAllowedSecurityType){
        return this.displayOrder(rowItem.orderType);
        }
       else{
        return this.displayNotApplicable();
      }
   }else{
      return this.displayBlank();
     }
   }    
  }
 
  cellRendererSelectorPrice(params: any,inventoryComponent:InventoryComponent){
    var dashsupSymb = "<span style='position: relative; top: -4px; font-size: 10px;'>&#8224;</span>";
    if (params.data) {
      let isAllowedSecurityType = (params.data.securityType == "Equity" || params.data.securityType == "Option");
      if (!isAllowedSecurityType) {
        return this.displayNotApplicable();
      }
      const defaultOrderPriceType = params.data.defaultOrderPriceType ? params.data.defaultOrderPriceType.toUpperCase() : '';
      if(params.data.orderType === "Market" ){
        return {
          component: 'cellRendererFormatter',
          params:{
            value: 'M',
            link: (params: any) => {
                return !inventoryComponent.isDisabled(params.data) && params.data.orderType === "Market";
            },
            onClick: () => {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                data: params,
                parent: inventoryComponent,
                actionType: 'SingleEdit',
                tradeInstructionsinit: true
              });
            },
          }
        }
      } else if (params.data.orderType === "Limit" && (defaultOrderPriceType === "ASK" || defaultOrderPriceType === "BID" ||
        defaultOrderPriceType === "LAST TRADE" || defaultOrderPriceType === "MIDPOINT")) {

          return {
            component: 'cellRendererFormatter',
            params: {
              value: params.data.defaultOrderPriceType + ' ' +params.data.price,
              template: `<div class="inv-grid-col-price"><span class="inv-grid-col-price-type">${params.data.defaultOrderPriceType}</span>
                <sup class="inv-grid-col-price-sup">&#8224;</sup>
                <span class="inv-grid-col-price-value">
                    ${params.data.price ? '$'+ params.data.price.toFixed(2): (params.data.price == null || params.data.price == '') ? 'n/a': '$'+ params.data.price}
                </span></div>`,
              link: (params: any) => {
                const priceValDummy: string = (params.data.defaultOrderPriceType || '') + params.data.price;
                  return !inventoryComponent.isDisabled(params.data) && (priceValDummy != null && priceValDummy !== '');
              },
              onClick: () => {
                inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                  data: params,
                  parent: inventoryComponent,
                  actionType: 'SingleEdit',
                  tradeInstructionsinit: true
                });
              },
            }
          }
      } else if (params.data.orderType === "Stop Limit" || params.data.orderType === "STOPLIMIT") {
        let limitPrice = params.data.ordLimitPrice; if (!limitPrice) { limitPrice = params.data.price; }
        return {
          component: 'cellRendererFormatter',
          params: {
            value: (limitPrice ? 'L ' + limitPrice.toFixed(2):'') + '  ' +
              (params.data.ordStopPrice ? 'S ' + params.data.ordStopPrice.toFixed(2): '') ,
            template: `<div class="inv-grid-col-price"><span class="inv-grid-col-price-type">
            L&nbsp;${ limitPrice ? '$'+ limitPrice.toFixed(2):''}
                &nbsp;&nbsp;S&nbsp;${params.data.ordStopPrice ? '$'+ params.data.ordStopPrice.toFixed(2): ''}
                </span></div>`,
            link: (params: any) => {
                // false && console.log(params);
                return !inventoryComponent.isDisabled(params.data) && (limitPrice != null && limitPrice !== '');
            },
            onClick: () => {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                data: params,
                parent: inventoryComponent,
                actionType: 'SingleEdit',
                tradeInstructionsinit: true
              });
            },
          }
        }

      } else if (params.data.orderType === "Trailing Stop %" || params.data.orderType === "TRAILING_STOP_PRC") {
        return {
          component: 'cellRendererFormatter',
          params: {
            value: params.data.price ? params.data.price + '%' : params.data.price,
            link: (params: any) => {
                // false && console.log(params);
                return !inventoryComponent.isDisabled(params.data) && (params.data.price != null && params.data.price !== '');
            },
            onClick: () => {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                data: params,
                parent: inventoryComponent,
                actionType: 'SingleEdit',
                tradeInstructionsinit: true
              });
            },
          }
        };
      } else {
        return{
          component: 'cellRendererFormatter',
          params:{ value: params.data.price ? '$'+ params.data.price.toFixed(2): (params.data.price == null || params.data.price == '') ? 'n/a': '$'+ params.data.price,
            link: (params: any) => {
                // false && console.log(params);
                return !inventoryComponent.isDisabled(params.data) && (params.data.price != null && params.data.price !== '');
            },
            onClick: () => {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                data: params,
                parent: inventoryComponent,
                actionType: 'SingleEdit',
                tradeInstructionsinit: true
              });
            },
          }
        }
      }
    }
  }

  cellRendererSelectorExpirationType(params: any,inventoryComponent:InventoryComponent){

    let returnValue = '';
    const rowItem = params.data; 
    if(rowItem){  
    if (rowItem.isBlockOrder || rowItem.isBlockOrder == null) {

      let isOption = rowItem.securityType == "Option";
      let isAllowedSecurityType = (rowItem.securityType == "Equity" || rowItem.securityType == "Option");
      let isAllowedOptionTrading = (inventoryComponent.isOptionTradeEnabled && isOption) || !isOption;

      if (isAllowedSecurityType && isAllowedOptionTrading) {
         return this.formatTradeInstruction(rowItem.expirationType,params,inventoryComponent);
      } else if (isAllowedSecurityType) {
        return rowItem.expirationType;
      } else {
        return this.displayNotApplicable();
      }
    } else
      return this.displayBlank();
   }
  }

  cellRendererSelectorExpirationDate(params: any,inventoryComponent:InventoryComponent){      
    const rowItem = params.data;   
   if(rowItem){
    if (rowItem.isBlockOrder || rowItem.isBlockOrder == null) {

      let isOption = rowItem.securityType == "Option";
      let isAllowedSecurityType = (rowItem.securityType == "Equity" || rowItem.securityType == "Option");
      let isAllowedOptionTrading = (inventoryComponent.isOptionTradeEnabled && isOption) || !isOption;
      if (isAllowedSecurityType && isAllowedOptionTrading) { 
        if (rowItem.expirationType == "Day") {
          return this.displayNotApplicable();
        } else {
          return this.viewExpirationDate(rowItem.expirationDate,params,inventoryComponent);
        }
      }else if (rowItem.securityType == "Equity" && (rowItem.expirationType == "GTD" || rowItem.expirationType == "GTDEXT")) {
        return this.displayValueWithFormatter(rowItem.expirationDate);
       }else{
        return this.displayNotApplicable();
      }
    }
    else{
      return this.displayBlank();
    }
   }
  }

  displayValueWithFormatter(value:any){
    return {
      component: 'cellRendererFormatter',
      params:{ value: value,format: 'MM.dd.yyyy' } 
      }

  }
  displayNotApplicable(){
    return {
      component: 'cellRendererFormatter',
      params:{ value: 'n/a' } 
      }
  }

  displayBlank(){
    return {
      component: 'cellRendererFormatter',
      params:{ value: '' } 
      }
  }

  viewExpirationDate(returnValue:any,params:any,inventoryComponent:InventoryComponent){    
      return {
          component: "cellRendererFormatter",
          params: {
            type: 'date', format: 'MM/dd/yyyy',
            value:returnValue,
            link: (params: any) => {
              return params.value !== null
            },
            onClick: function () {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit',tradeInstructionsinit:true });
            }.bind(this),
          },
        };      
   }
    
  formatTradeInstruction(returnValue:any,params:any,inventoryComponent:InventoryComponent){

       return {
          component: "cellRendererFormatter",
          params: {
            value:returnValue,
            link: (params: any) => {
              return params.value !== null && params.value.length > 0;
            },
            onClick: function () {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit',tradeInstructionsinit:true });
            }.bind(this),
          },
        };      
      }   
  

 displayOrder(value:any){
        return {
          component: 'cellRendererFormatter',
          params:{ value: value } 
          }
    }


  cellRendererSelectorNotHeld(params:any,inventoryComponent:InventoryComponent){
      const rowItem = params.data;
    if(rowItem){     
			let orderStatus = rowItem.orderStatus;
      let ordIsNotHeld = rowItem.ordIsNotHeld;
      
      if (rowItem.securityType != "Equity"){
      return this.displayNotApplicable();
      }
    else {
      // sa 2021-04-27 todo: ask for any hidden tricks and replace with single line if none
      // if (ordIsNotHeld || ordIsNotHeld == true) {
      //   if (orderStatus == "Approved" || orderStatus == "Warning")
      //     return this.displayNotHeld(params,inventoryComponent);
      //   else
      //     return  this.displayNotHeld(params,inventoryComponent);
      // } else {
      //  if (orderStatus == "Approved" || orderStatus == "Warning"){
      //   return this.displayNotHeld(params,inventoryComponent);
      //  }
      //   else{
      //     return this.displayNotHeld(params,inventoryComponent);
      //   }
      // }
      return this.displayNotHeld(params,inventoryComponent);
    }
   }
  }

  displayNotHeld(params:any,inventoryComponent:InventoryComponent){
   
    return {
      component: "cellRendererFormatter",
      params:{
      type: 'checkbox', isCheckedValue:false, // isCheckboxDisabled:true,
         value:params.data.ordIsNotHeld,
         retainValue: function () {
          inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit', tradeInstructionsinit:true });
        }.bind(this),
       }
      }    
  }

  cellRendererSelectorRvstDIVs(params:any,inventoryComponent:InventoryComponent){
  
    let isEditable = true;
    let isAvailable = true;
    const rowItem = params.data;
    if(rowItem){
    if (rowItem.isBlockOrder || rowItem.isBlockOrder == null) {
      if (rowItem.securityType !== 'Mutual Fund') {
        return this.displayNotApplicable();
      }
      if (rowItem.isBlockOrder == null) {
        if (rowItem.securityType == "Mutual Fund" && rowItem.orderStatus != "Submitted" && rowItem.orderStatus != 'SUBMITTED_TO_VEO')
          isEditable = true;
        else
          isEditable = false;
      } else
        isEditable = false;

        return {
          component: "cellRendererFormatter",
          params:{
          type: 'checkbox', isCheckboxDisabled: !isEditable,
             value:rowItem.isDividendReinvest,
             isCheckedValue:false,
             retainValue: function () {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit',reinvestmentinit:true });

             }.bind(this)
          }
        }
    } else
      return this.displayBlank();
    }
  }

   cellRendererSelectorRvstCGs(params:any,inventoryComponent:InventoryComponent){   
    let isEditable = true;
    const rowItem = params.data;
    if(rowItem){
    if (rowItem.isBlockOrder || rowItem.isBlockOrder == null) {
      if (rowItem.securityType !== 'Mutual Fund') {
        return this.displayNotApplicable();
      }
      if (rowItem.isBlockOrder == null) {
        if (rowItem.securityType == "Mutual Fund" && rowItem.orderStatus != "Submitted" && rowItem.orderStatus != 'SUBMITTED_TO_VEO')
          isEditable = true;
        else
          isEditable = false;
      } else
        isEditable = false;

        return {
          component: "cellRendererFormatter",
          params: {
            type: 'checkbox', isCheckboxDisabled: !isEditable,
             value:rowItem.isCapGainsReinvest,
             isCheckedValue:false,
             retainValue: function () {
              inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit',reinvestmentinit:true });
             }.bind(this)
           },
          }; 
    } else{
      return this.displayBlank();
    }
   }
  }

   cellRendererSelectorFee(params:any){   
    const rowItem = params.data; 
   if(rowItem){
    if (rowItem.isBlockOrder == null) {
      if (rowItem.securityType == "Mutual Fund") {
        if (rowItem.orderStatus == "Submitted" || rowItem.orderStatus == "SUBMITTED_TO_VEO" || rowItem.transactionType == "Sell All" ||
          (rowItem.transactionType == "Sell" && rowItem.amountType == "Shares")){
          return this.displayFeeOption(rowItem.feesOption);
          }
        else{
          return this.displayFeeOption(rowItem.feesOption);
      }
     } else{
        return this.displayNotApplicable();
     }
    } else{
      return this.displayBlank();
    }
   }
  } 
  
  displayFeeOption(value:any){
    return {
      component: 'cellRendererFormatter',
      params:{ value: value } 
      }

  }

  cellRendererSelectorSol(params:any,inventoryComponent:InventoryComponent){ 
    const rowItem = params.data; 
    if(rowItem){
      let isEditable = false;
			if (rowItem.orderStatus != "Submitted" && rowItem.orderStatus != 'SUBMITTED_TO_VEO'){
        isEditable = true;
      }
      return {
        component: "cellRendererFormatter",
        params: {
          type: 'checkbox', isCheckboxDisabled: !isEditable,
          value:rowItem.isSolicited,
          isCheckedValue:false,
          retainValue: function () {
            inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit', tradeInstructionsinit:true });
          }.bind(this),
         },
        }; 
      }
  }
  
  cellRendererSelectorDisc(params:any,inventoryComponent:InventoryComponent){ 
    const rowItem = params.data; 
    if(rowItem){
    let isEditable = false;
			if (rowItem.orderStatus != "Submitted" && rowItem.orderStatus != 'SUBMITTED_TO_VEO'){
        isEditable = true;
      }
      return {
        component: "cellRendererFormatter",
        params: {
          type: 'checkbox', isCheckboxDisabled: !isEditable,
          value:rowItem.isDiscretionary,
          isCheckedValue:false,
          retainValue: function () {
            inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent, actionType: 'SingleEdit', tradeInstructionsinit:true });
          }.bind(this),
         },
        }; 
      }
  }

  formatTransType(params:any) {
    const rowItem = params.data; 
if(rowItem){
    let isRollTrade =rowItem.isRollTrade;
    let returnVal = rowItem.transactionType;  
    let secType = rowItem.securityType;
  
    if (isRollTrade) {
      let fromSecReturnVal = rowItem.transactionType;
      let toSecTransType = rowItem.toSecTransType;
      let toSecReturnVal = toSecTransType;
      returnVal = fromSecReturnVal +" <br/> "+ toSecReturnVal;
    } else if (returnVal === "Sell All" && (secType === "Mutual Fund" || secType === "Equity")) {
      returnVal = "Sell All *";
    } else if (returnVal === "Swap All") {
      returnVal = "Swap All *";
    } else if (returnVal === "Exch All" || returnVal === "Exchange All") {
      returnVal = "Exch All *";
    } else if (returnVal === "Exchange") {
      returnVal = "Exch";
    }
    return {
      component: "cellRendererFormatter",
      params: {
         value:returnVal, 
         template: `<div >${returnVal}</div>`,
       },
      }
  }
 }

 cellRendererSelectorOrderHistory(params:any,inventoryComponent:InventoryComponent,blockOrder:boolean){ 
 const rowItem = params.data; 
 if(rowItem){
   return {
     component: "cellRendererFormatter",
     params: { 
     value:"View",        
     link: (params: any) => { 
       return (params.value != null && params.value.length > 0);
     },
     onClick: ( () => {
       if(blockOrder){
       inventoryComponent.orderHistoryDialog(params,inventoryComponent);
       }else{
        inventoryComponent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: inventoryComponent,orderhistoryinit:true });
       }
     })}
   }
  }
 }

 updateAmtType(params:any) {
  const rowItem = params.data; 

if(rowItem){
  let thisSecType = formatSecurityTypeReverse(rowItem.securityType);
  let thisTransType = formatTransactionReverse(rowItem.transactionType);
  let thisSellPrice = rowItem.accountHoldingPercentageIndicator;
  let thisStatus = rowItem.orderStatus;
  let isImported = rowItem.isImported;
  let returnVal;

  switch (rowItem.amountType) {
    case "SHARES":
      returnVal = "Shares";
      break;
    case "DOLLARS":
      returnVal = "Dollar";
      break;
    default:
      returnVal = rowItem.amountType;
    }

    let hasCorrectTransType = (thisTransType == "SELL");

			if (!isImported && thisSecType == "MUTUAL_FUND" && hasCorrectTransType && thisSellPrice == "0" && thisStatus == "APPROVED") {
				return {
          component: "cellRendererFormatter",
          params: {
             value:returnVal, 
             type: 'dropdown'
           },
          }
			} else {
				return {
          component: "cellRendererFormatter",
          params: {
             value:returnVal
           },
          }
			}  
   }
 }

 isAmtTypeEditable(params: any){
  const rowItem = params.data; 

    if(rowItem){
      let thisSecType = formatSecurityTypeReverse(rowItem.securityType);
      let thisTransType = formatTransactionReverse(rowItem.transactionType);
      let thisSellPrice = rowItem.accountHoldingPercentageIndicator;
      let hasCorrectTransType = thisTransType == "SELL";

      if (!rowItem.isImported && thisSecType == "MUTUAL_FUND" && hasCorrectTransType && thisSellPrice == "0" && rowItem.orderStatus == "APPROVED") {
        return true; 
      }    
    }
    
    return false;
  }
  
  formatShareQuantity(params: any) {
    let value = 0;
    if (params && params.data) {
      if (params.data.amountType) {
        if (params.data.amountType === 'Dollars') {
          return {
            component: 'cellRendererFormatter',
            params: {value: 'n/a'}
          }
        }
      }
      if (params.data.quantity && !isNaN(params.data.quantity)) {
        value = params.data.quantity;
      }
    }
    
    return {
      component: 'cellRendererFormatter',
      params: { type: "currency", displaySymbol: " ", decimalPosition: '4'}
    }
  }

  tradingValueRenderer(params: any) {
      if (params && params.data) {
          if (params.data.securityType === 'Mutual Fund') {
              return this.displayBlank();
          } else {
              return {
                  component: 'cellRendererFormatter',
                  params: {type: 'percent', displaySymbol: '%',decimalPosition:'2'}
              }
          }
      } else
        return this.displayBlank();
  }
 }
